/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupMappings } from './LookupMappings';
import {
    LookupMappingsFromJSON,
    LookupMappingsFromJSONTyped,
    LookupMappingsToJSON,
} from './LookupMappings';

/**
 * 
 * @export
 * @interface ListLookupMappingsResponseContent
 */
export interface ListLookupMappingsResponseContent {
    /**
     * 
     * @type {LookupMappings}
     * @memberof ListLookupMappingsResponseContent
     */
    mappings: LookupMappings;
}


/**
 * Check if a given object implements the ListLookupMappingsResponseContent interface.
 */
export function instanceOfListLookupMappingsResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mappings" in value;

    return isInstance;
}

export function ListLookupMappingsResponseContentFromJSON(json: any): ListLookupMappingsResponseContent {
    return ListLookupMappingsResponseContentFromJSONTyped(json, false);
}

export function ListLookupMappingsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLookupMappingsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mappings': LookupMappingsFromJSON(json['mappings']),
    };
}

export function ListLookupMappingsResponseContentToJSON(value?: ListLookupMappingsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mappings': LookupMappingsToJSON(value.mappings),
    };
}

